const estudioGrupoInitialState = {
    estudioGrupo: {
      loading: false,
      error: null,
      data: null,
      dataOriginal: null, // Lista completa sin filtrar por edad
    },
    estudiosMasBuscado: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default estudioGrupoInitialState;